import storeRegistrationAPI from "@/apis/storeRegistration"
import memberAPI from "@/apis/member"
import smsAPI from "@/apis/sms"
import emailAPI from "@/apis/email"
export default {
  install(Vue) {
    Vue.prototype.$apis = {
      storeRegistrationAPI,
      memberAPI,
      smsAPI,
      emailAPI
    }
  }
}